var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShutdown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 26,
    width: 26,
    viewBox: "0 0 40 40",
    fill: "currentColor",
    className: "text-samurai-gray-300 dark:text-samurai-gray-100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.625 21.708V4.875h2.75v16.833ZM20 35.042q-3.083 0-5.813-1.188-2.729-1.187-4.77-3.229-2.042-2.042-3.229-4.771Q5 23.125 5 20.042q0-3.334 1.396-6.25 1.396-2.917 3.979-5.125l1.958 1.958q-2.166 1.75-3.354 4.187-1.187 2.438-1.187 5.23 0 5.083 3.562 8.666 3.563 3.584 8.646 3.584 5.125 0 8.667-3.584 3.541-3.583 3.541-8.666 0-2.792-1.187-5.271-1.188-2.479-3.313-4.146l2-1.958q2.5 2.125 3.896 5.083T35 20.042q0 3.083-1.188 5.812-1.187 2.729-3.208 4.771t-4.75 3.229Q23.125 35.042 20 35.042Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShutdown);
export default __webpack_public_path__ + "static/media/shutdown.f0d56d67f074f8581bd6839a1a4329b6.svg";
export { ForwardRef as ReactComponent };